// extracted by mini-css-extract-plugin
module.exports = {"balanceContainer":"Balancebar_balanceContainer__1QYg0","text":"Balancebar_text__23DPQ","score":"Balancebar_score__3ZKE7"};